import { EquipmentFormValue } from '../types';

export function prepareCreateUpdateEquipmentDTO(formData: EquipmentFormValue) {
  const { commonInfo, attachments, year, make, model } = formData;

  return {
    make,
    model,
    year,
    attachments,
    mileage: commonInfo.mileage,
    stockId: commonInfo.stockId,
    classType: commonInfo.class,
    quantity: commonInfo.quantity,
    truckClass: parseInt(commonInfo.class?.replace(/\D/g, '') ?? '', 10) ?? null,
    newUsed: commonInfo.condition,
    wholesaleCost: commonInfo.saleCost,
    retailPrice: commonInfo.retailPrice,
    serialNumberVin: commonInfo?.vin?.trim(),
    totalWholesaleCost: commonInfo.wholeSaleCost,
    additionalDescription: commonInfo.description,
    inventoryItem: {
      status: commonInfo.inventoryItem.status,
    },
  };
}
